// extracted by css-extract-rspack-plugin
export default {"Header":"SuggestionFileDisclosure-module__Header__uK22h","Path":"SuggestionFileDisclosure-module__Path__TY1s8"};